import { render } from "./ContactView.vue?vue&type=template&id=1a9b5414&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=1a9b5414&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Henrik Bergmann\\Documents\\App-Unvergessen-Agency\\app-unvergessen-agency\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9b5414"]])

export default __exports__